export default function DirtyWarning() {
  return (
    <div>
      <p className="mr-2 flex items-center gap-2 text-xs text-yellow-600">
        <span className="h-2 w-2 rounded-full bg-yellow-500" />
        Ungespeicherte Änderungen
      </p>
    </div>
  );
}
